import ReExecuteIntegrationCallRequestModelBase from '../_generated/modelBases/re-execute-integration-call-request-model-base';

export default class ReExecuteIntegrationCallRequestModel extends ReExecuteIntegrationCallRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
